




















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class ConfirmationDialog extends Vue {
    @Prop({ type: Boolean, default: false }) public noCloseOnEsc!: boolean;
    @Prop({ type: Boolean, default: false }) public noCloseOnbackdrop!: boolean;
    @Prop({ type: String, default: 'Are you sure?' }) public title!: string;
    @Prop({ type: String, default: 'primary' }) public variant!: string;
    @Prop({ type: String, default: 'secondary' }) public cancelVariant!: string;
    @Prop({ type: String, default: 'OK' }) public okText!: string;
    @Prop({ type: String, default: 'Cancel' }) public cancelText!: string;
    @Prop({ type: Boolean, default: false, required: true }) public value!: boolean;

    private isVisible: boolean = this.value;

    @Watch('value') private handleValueChanged(show: boolean): void {
        this.isVisible = show;
    }

    public show(): void {
        this.isVisible = true;
    }
    public hide(): void {
        this.isVisible = false;
    }

    public handleOk(e: any): void {
        this.$emit('ok', e);
    }
    public handleCancel(e: any): void {
        this.$emit('cancel', e);
    }
}
